function shouldLoadAllProjectsForProjectsRoute({
    toPath,
    isAuthenticated,
    isInitialDataLoaded,
    areAllProjectsLoaded,
    isProjectsLoading,
}) {
    return (
        toPath === "/projects" &&
        isAuthenticated &&
        isInitialDataLoaded &&
        !areAllProjectsLoaded &&
        !isProjectsLoading
    );
}

module.exports = {
    shouldLoadAllProjectsForProjectsRoute,
};
